// extracted by mini-css-extract-plugin
export default {"checkoutButton":"Checkout_checkoutButton__xiWKz"};